export const faqs = [
    {
      question: "What is our service?",
      answer: "Our service provides streaming of various movies and TV shows on different devices including smartphones, tablets, and TVs."
    },
    {
      question: "How much does it cost?",
      answer: "We offer several plans to suit your needs. Choose from our Basic, Standard, or Premium plans with varying features and pricing."
    },
    {
      question: "Where can I watch?",
      answer: "You can watch on any device that supports our app, including phones, tablets, smart TVs, and more. Enjoy your favorite shows anywhere, anytime."
    },
    {
      question: "How do I cancel?",
      answer: "Canceling is easy. You can do it online at any time. There are no cancellation fees and you can restart your account whenever you like."
    },
    {
      question: "What can I watch?",
      answer: "We have a vast library of movies, TV shows, documentaries, and more. There's always something new to discover."
    },
    {
      question: "How does the free trial work?",
      answer: "You can sign up for a free trial to experience our service. If you enjoy it, you can continue with a paid plan. Cancel before the trial ends to avoid charges."
    }
  ];